<template>
  <div style="width: 24px; height: 24px;">
    <v-img v-if="user.avatarUrlSmall" class="avatarImage" :src="user.avatarUrlSmall" />
    <v-icon left v-else-if="isWildcard" style="padding-bottom:0.2em;">mdi-guy-fawkes-mask</v-icon>
    <v-icon v-else left>mdi-account</v-icon>
    <div style="position:relative;">
      <v-icon
        class=""
        v-if="user.isAdmin"
        small
        style="position:absolute;right:-6px;top:-32px;"
      >mdi-hammer-wrench</v-icon>
      <v-icon
        class="premium-icon"
        v-if="user.premium && isPremiumFeatureEnabled()"
        small
        style="position:absolute;right:-5px;bottom:-5px;"
      >mdi-star-circle-outline</v-icon>
    </div>
  </div>
</template>

<script>
import envMixin from "@/mixins/envMixin";
export default {
  name: "PlayerAvatar",
  mixins: [envMixin],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    isWildcard: function() {
      return this.user.name == '*'
    }
  }
};
</script>

<style scoped>
.avatarImage {
  border-radius: 20%;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>